<div class="trusted-partner">
  @if (partnerUrl) {
    <a style="color: transparent; cursor: pointer; text-decoration: none;" href="{{partnerUrl}}"
      target="_blank">
      <img alt="{{partnerAlt}}" height="50" width="327" src="{{imgSrc}}">
    </a>
  }
  @if (!partnerUrl) {
    <img alt="{{partnerAlt}}" height="50" width="327" src="{{imgSrc}}">
  }
</div>